export function getView(value) {
  return ['receivables', 'transactions'].includes(value)
}
